import css from 'styled-jsx/css';

const styles = css.global`.banner-container {
  position: relative;
  width: 100%;
  height: 102px;
  box-sizing: border-box;
}

.banner-container h1 {
  color: #ffffff;
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: normal;

  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 999;
  left: 16px;
  bottom: 24px;
}

.banner-container amp-img img {
  object-fit: cover;
}

.banner-container.ampless {
  overflow: hidden;
}

.banner-container.ampless img {
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 0;
  max-height: 100%;
  max-width: 100%;
  min-height: 100%;
  min-width: 100%;
  width: 0;
  margin: auto;
}

.banner-container .img-mobile {
  display: block;
}

.banner-container .img-desktop {
  display: none;
}

.banner-container .img-mobile-right {
  object-position: right;
}

@media (min-width: 768px) {
  .banner-container {
    height: 200px;
  }

  .banner-container h1 {
    color: #ffffff;
    font-family: 'SantanderHeadline';
    font-size: 48px;
    letter-spacing: 0;
    line-height: 50px;
    bottom: 64px;
    left: 24px;
  }
}

@media (min-width: 992px) {
  .banner-container .img-mobile {
    display: none;
  }

  .banner-container .img-desktop {
    display: block;
  }

  .banner-container.d-top-margin {
    margin-top: 48px;
  }

  .banner-container .img-desk-right {
    object-position: right;
  }
}
`;

export default styles;